/* eslint-disable @typescript-eslint/no-explicit-any */
import { CompareFn } from 'antd/lib/table/interface';
import dayjs from 'dayjs';
import { EFieldType, IFieldMeta } from 'shared/types/Page.interface';
import {
  compareDates, compareString, compareStringBySortMap, concatString,
} from 'shared/utils';

interface SorterObject {
  compare?: CompareFn<any>;
  multiple?: number;
}

export const getColumnSorter = (column: IFieldMeta): SorterObject => {
  const disabledSortColumn = [EFieldType.tags];
  if (disabledSortColumn.includes(column.type)) return undefined;
  return {
    compare: (a: any, b: any) => {
      const first = a[column.dataIndex];
      const second = b[column.dataIndex];
      switch (column.type) {
      case EFieldType.dateTime:
        return compareDates(dayjs(first, column.sourceFormat), dayjs(second, column.sourceFormat));
      case EFieldType.select:
        return column.sortingMap
          ? compareStringBySortMap(column.options[first], column.options[second], column.sortingMap)
          : compareString(column.options[first], column.options[second]);
      case EFieldType.colored:
        return column.sortingMap
          ? compareStringBySortMap(column.selectOptions[first], column.selectOptions[second], column.sortingMap)
          : compareString(column.selectOptions[first], column.selectOptions[second]);
      case EFieldType.template:
        return compareString(
          concatString(column.keys.map(((key) => a[key] as string))),
          concatString(column.keys.map(((key) => b[key] as string))),
        );
      case EFieldType.picklist:
        return compareString(
          first?.[column.pickMap.valueKey],
          second?.[column.pickMap.valueKey],
        );
      default:
        return compareString(first, second);
      }
    },
    multiple: column.sortingPriority,
  };
};
